var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "select",
      staticClass: "c-select-dropdown__menu--wrapper",
      class: { "c-select-dropdown__menu--isopen": _vm.isOpen }
    },
    [
      _c("div", { staticClass: "c-select-dropdown__menu--inner" }, [
        _c(
          "button",
          {
            staticClass: "c-select-dropdown__menu--header",
            attrs: {
              "aria-label": "Väljare",
              "aria-controls": "c-select-dropdown-menu-items-container"
            },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.keyboardHandler($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onToggle($event)
                }
              ],
              click: _vm.onToggle
            }
          },
          [
            _c(
              "div",
              { staticClass: "c-select-dropdown__menu--header-content" },
              [
                _vm.icon
                  ? _c(
                      "div",
                      { staticClass: "c-select-dropdown__menu--headericon" },
                      [_c("v-icon", { attrs: { name: _vm.icon, size: "s" } })],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.showDefaultHeader
                      ? _c("span", [_vm._v(_vm._s(_vm.defaultHeader))])
                      : _vm._t("header", null, {
                          active: _vm.active,
                          selectedItems: _vm.selectedItems
                        })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-select-dropdown__menu--toggleicon" },
              [_c("v-icon", { attrs: { name: "icon-chevron" } })],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "c-select-dropdown__menu--items",
            attrs: {
              id: "c-select-dropdown-menu-items-container",
              role: "menu",
              "aria-expanded": _vm.isOpen ? "true" : "false"
            }
          },
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "button",
              {
                key: item.id,
                ref: "menuItems",
                refInFor: true,
                staticClass: "c-select-dropdown__menu--item",
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onClick(item, index)
                  },
                  click: function($event) {
                    return _vm.onClick(item, index)
                  }
                }
              },
              [
                _vm._t("item", null, { item: item }),
                _vm._v(" "),
                _vm.isActive(item)
                  ? _c("v-icon", {
                      attrs: { name: _vm.selectedIcon, size: "xs" }
                    })
                  : _vm._e()
              ],
              2
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }